import React, { SVGProps } from 'react';

export const PaymentIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 21,
  height = 21,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 21 21"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 4.25H3C2.66848 4.25 2.35054 4.3817 2.11612 4.61612C1.8817 4.85054 1.75 5.16848 1.75 5.5V15.5C1.75 15.8315 1.8817 16.1495 2.11612 16.3839C2.35054 16.6183 2.66848 16.75 3 16.75H18C18.3315 16.75 18.6495 16.6183 18.8839 16.3839C19.1183 16.1495 19.25 15.8315 19.25 15.5V5.5C19.25 5.16848 19.1183 4.85054 18.8839 4.61612C18.6495 4.3817 18.3315 4.25 18 4.25ZM18 5.5V7.375H3V5.5H18ZM3 15.5V8.625H18V15.5H3Z"
        fill="white"
      />
      <path d="M4.25 13H10.5V14.25H4.25V13Z" fill="white" />
    </svg>
  );
};
